import React from 'react'
import { SocialIcon } from 'react-social-icons'

const Contact = () => {
    return (
        <main id="contact" className="py-16 sm:py-20 px-4 sm:px-8 bg-gradient-to-b from-slate-50 to-white">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-center pb-4 text-slate-900 relative">
                    Get In Touch
                    <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-blue-600 rounded-full"></div>
                </h1>
                <p className="text-center text-lg sm:text-xl text-slate-600 mt-8 mb-12 max-w-2xl mx-auto">
                    Feel free to reach out! I'm always open to discussing new projects, creative ideas, or opportunities.
                </p>

                <div className="bg-white rounded-2xl shadow-xl p-8 sm:p-12 border border-slate-200">
                    <h2 className="text-2xl sm:text-3xl font-bold text-center mb-8 text-slate-900">
                        Connect With Me
                    </h2>

                    <section className="flex flex-wrap gap-6 sm:gap-8 justify-center items-center mb-8">
                        <a
                            href="https://www.linkedin.com/in/nicholas-gitman/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="transform transition-all duration-300 hover:scale-110 hover:-translate-y-2"
                        >
                            <SocialIcon
                                url="https://www.linkedin.com/in/nicholas-gitman/"
                                style={{ height: 64, width: 64 }}
                            />
                        </a>
                        <a
                            href="https://github.com/ngitman/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="transform transition-all duration-300 hover:scale-110 hover:-translate-y-2"
                        >
                            <SocialIcon
                                url="https://github.com/ngitman/"
                                style={{ height: 64, width: 64 }}
                            />
                        </a>
                        <a
                            href="https://app.joinhandshake.com/profiles/yc332b"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="transform transition-all duration-300 hover:scale-110 hover:-translate-y-2"
                        >
                            <SocialIcon
                                url="https://app.joinhandshake.com/profiles/yc332b"
                                style={{ height: 64, width: 64 }}
                            />
                        </a>
                        <a
                            href="https://www.instagram.com/djnicny/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="transform transition-all duration-300 hover:scale-110 hover:-translate-y-2"
                        >
                            <SocialIcon
                                url="https://www.instagram.com/djnicny/"
                                style={{ height: 64, width: 64 }}
                            />
                        </a>
                    </section>

                    <div className="border-t border-slate-200 pt-8 mt-8">
                        <p className="text-center text-slate-600 text-base sm:text-lg">
                            Looking forward to connecting with you!
                        </p>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default Contact